import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { PatientResponse } from '../../api/generated';
import type { RootState } from '../index';

interface PatientsState {
  byId: Record<string, PatientResponse>;
}

const initialState: PatientsState = {
  byId: {}
};

const patientsSlice = createSlice({
  name: 'patients',
  initialState,
  reducers: {
    setPatients: (state, action: PayloadAction<PatientResponse[]>) => {
      const byId: Record<string, PatientResponse> = {};
      for (const patient of action.payload) {
        if (patient.id) {
          byId[patient.id] = patient;
        }
      }
      state.byId = byId;
    },
    clearPatients: (state) => {
      state.byId = {};
    }
  }
});

export const { setPatients, clearPatients } = patientsSlice.actions;

export const selectPatientName = (state: RootState, patientId: string | undefined) =>
  patientId ? state.patientsSlice.byId[patientId]?.name : undefined;

export const selectPatientsById = (state: RootState) => state.patientsSlice.byId;

export default patientsSlice.reducer;
